import { observer } from "mobx-react";
import CreateRmaFuqStore from "../stores/create-rma-fuq-store";
import Stepper from "../../../components/stepper/stepper";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";
import "./numeric-stepper-crma-fuq-answer.scss";

interface NumericStepperFuqQuestionProps {
    question: CreateRmaFuqStore;
}

const NumericStepperCRmaFuqAnswer: React.FC<NumericStepperFuqQuestionProps> = observer(({question}) => {

    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';
    
    const stepperValue = Number(question.answers[0].answer ?? 0);

    const onChange = (v: number) => {
        question.answers[0].setAnswer((v ?? '').toString());
    }

    return (
        <div className="c-rma-fuq-numeric-stepper">
            <Stepper
                value={stepperValue}
                onChange={onChange}
                max={question.stepperMaxValue}
                min={question.stepperMinValue ?? 0}
                label={getTranslation('DAYS', pageScope)}
            />
        </div>        
    );
      

});
export default NumericStepperCRmaFuqAnswer;